<div class="forgot-password-message flex flex-column center gap-30">
  <div class="forgot-password-message-body">
    <img src="assets/images/svg/send-mail-icon.svg" alt="" width="80" height="80" />
    <div
      class="description"
      [innerHTML]="
        'If an account exists for emailaddress, we have sent an email with instructions to reset your password.'
          | translate: { link: mailToLink, email }
      "
    ></div>
    <div class="w-full flex flex-column center gap-15">
      <app-button [label]="'button.Login' | translate" (click)="handleLogin()" />
      <app-button
        [label]="countdown > 0 ? `${'button.Resend in' | translate} (${countdown}s)` : ('button.Resend Email' | translate)"
        (click)="handleResendEmail()"
        variant="tertiary"
        [disabled]="countdown > 0 ? 'true' : undefined"
      />
    </div>
  </div>
</div>
